import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import CreateCampaignSplash from '~/Common-Objects/Onboarding/splashes/create-campaign.png'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function CampaignStep({ isOpen, isComplete, onClick, onCreateCampaign, postHogTag }) {
    return (
        <OnboardingStep
            key='campaign'
            title={i18n.t('setup:steps.create-campaign.title')}
            icon={<Icons icon='emailAddOutline' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.create-campaign.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onCreateCampaign()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.create-campaign.button-text')}
                </Button>
            </div>
        </OnboardingStep>
    )
}

CampaignStep.splash = <img src={CreateCampaignSplash} alt={i18n.t('setup:steps.create-campaign.title')} />
